import { Form } from '@unform/web';
import styled from 'styled-components';

export const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  max-width: 35rem;

  h4 {
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.4rem;
    font-weight: 500;
    color: var(--gray);
    margin-bottom: 2rem;
    text-align: center;
  }
`;
